<template>
  <v-container fluid class="admin-invoice">
    <v-row class="flex-grow-0">
      <v-col class="text-right">
        <v-btn color="primary"
               class="ml-2"
               @click="exportItems">
          {{ $t('export') }}
        </v-btn>
      </v-col>
    </v-row>
    <AdminInvoiceList full-height
                            @filter="onFilterChange"
                            :refresh-trigger.sync="bookingRefreshTrigger"></AdminInvoiceList>
  </v-container>
</template>
<script>
import {ref} from "@vue/composition-api";
import AdminInvoiceList from "@/components/acc_booking/invoice/AdminInvoiceList.vue";
import AddInvoiceModal from "@/components/acc_booking/invoice/AddInvoiceModal.vue";

export default {
  name: 'Invoice',
  components: {AdminInvoiceList},
  setup(props, {root}) {
    const bookingRefreshTrigger = ref(false);
    const refresh = function () {
      bookingRefreshTrigger.value = !bookingRefreshTrigger.value;
    };

    const exportItems = function () {
      root.$downloadFile("aafb/admin/invoice/export/", {
        filters: currentFilters.value,
      }, 'invoices.xlsx', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');
    }

    const create = async function () {
      const needRefresh = await root.$dialog.showAndWait(AddInvoiceModal, {
        showClose: false,
        persistent: true,
        width: '80vw',
      });

      if (needRefresh) {
        refresh();
      }
    }

    const currentFilters = ref(null);
    const onFilterChange = function (filters) {
      currentFilters.value = filters;
    }

    return {
      bookingRefreshTrigger,
      refresh,

      exportItems,
      create,
      onFilterChange,
    }
  }
}
</script>

<style lang="less">
.admin-invoice {
  height: 100%;
  display: flex;
  flex-direction: column;
}
</style>

